import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./Css/style.css";
import "./Css/responsive.css";
import "./Css/user-tracking.css";
import ApiContextProvider from "./Components/apiContext.js";
import { LoaderProvider } from "./helper/Loader.js";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ApiContextProvider>
    <LoaderProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </LoaderProvider>
  </ApiContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// index.js
